import React from 'react';
import ResourceList from './resource-list';

const InventoryItemList = (props) => (
    <ResourceList {...props} fields={['name', 'barcode']} path="/inventory-items/" />
);

export default InventoryItemList;